import type { MonthlyRow } from '@/utils/performanceData';

export interface MonthRow {
  id: string;
  month: string;
  profit: number;
  pct: number;
  balance: number;
}

export interface YearGroup {
  year: string;
  months: MonthRow[];
  profit: number;
  compoundedPct: number;
  closing: number;
  positive: number;
}

/** Group the monthly rows by calendar year and add a per-year subtotal. */
export function buildYearGroups(rows: MonthlyRow[]): YearGroup[] {
  const order: string[] = [];
  const map: Record<string, MonthRow[]> = {};

  rows.forEach((row) => {
    const year = row.id.slice(0, 4);
    if (!map[year]) {
      map[year] = [];
      order.push(year);
    }
    map[year].push(row);
  });

  return order.map((year) => {
    const months = map[year];
    const profit = months.reduce((sum, r) => sum + r.profit, 0);
    const compoundedPct = (months.reduce((acc, r) => acc * (1 + r.pct / 100), 1) - 1) * 100;
    const closing = months[months.length - 1].balance;
    const positive = months.filter((r) => r.profit >= 0).length;
    return { year, months, profit, compoundedPct, closing, positive };
  });
}